import { AppliedFiltersDetailsBody, ISelectedFiltersDetails } from './AppliedFiltersDetailsBody';
import { Button, Modal, Stack } from 'react-bootstrap';

import { useState } from 'react';

interface IAppliedFiltersView {
    children: React.ReactNode;
    hideSelectedFiltersIcon?: boolean;
    selectedFilterDetails?: ISelectedFiltersDetails[];
}

export function AppliedFiltersView(props: IAppliedFiltersView) {
    const [showFilterDetails, setShowFilterDetails] = useState(false);

    const handleToggleFilterDetailsModal = () => {
        setShowFilterDetails(true);
    };

    const handleModalClose = () => setShowFilterDetails(false);

    const hasSelectedFiltersDetails = (props.selectedFilterDetails?.length ?? 0) > 0;
    
    return (
        <>
            <Stack direction="horizontal" style={{ alignItems: 'start' }}>
                {!props.hideSelectedFiltersIcon && hasSelectedFiltersDetails && (
                    <Stack style={{ height: '100%', justifyContent: 'center' }}>
                        <i
                            className="fal fa-check-circle fa-lg color-gray"
                            onClick={handleToggleFilterDetailsModal}
                            style={{ cursor: 'pointer', width: 30 }}
                        />
                    </Stack>
                )}
                <Stack direction="horizontal" gap={2} style={{ flexWrap: 'wrap' }}>
                    {props.children}
                </Stack>
            </Stack>

            {showFilterDetails && (
                <Modal
                    centered
                    show={showFilterDetails}
                    size="lg"
                    onHide={handleModalClose}
                    backdropClassName="transparent-background"
                >
                    <Modal.Header>
                        <Modal.Title>Selected Filters</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AppliedFiltersDetailsBody details={props.selectedFilterDetails} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Stack direction="horizontal">
                            <Button variant="dark" onClick={handleModalClose}>
                                OK
                            </Button>
                        </Stack>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}
